import ComicCard from "@/components/base/ComicCard";
import { getHotComics, getRecommended } from "@/mocks/comics";
import { Link } from "react-router-dom";
import SectionHead from "./SectionHead";

export default function ComicSections() {
  const hot = getHotComics();
  const recommended = getRecommended();

  return (
    <>
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="flex items-end justify-between">
          <SectionHead
            eyebrow="热门连载"
            title="本周大家都在追"
            desc="热度最高、更新最勤的连载漫画，追更党不可错过的爆款合集。"
          />
          <Link
            to="/list"
            className="mb-8 hidden whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-xs text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600 sm:block"
          >
            进入漫库 →
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {hot.map((c) => (
            <ComicCard key={c.id} comic={c} />
          ))}
        </div>
      </section>

      <section className="bg-background-100 py-14">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <SectionHead
            eyebrow="编辑推荐"
            title="口碑佳作，值得一看"
            desc="由编辑和读者共同选出的高分连载，故事、画风与更新质量都过硬。"
          />
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {recommended.map((c) => (
              <ComicCard key={c.id} comic={c} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}